import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { isMobile } from '../../../utils/adaptive';
import { Carousel, CarouselArticle } from '../../carousel';
import { VideoArticle } from '../../article-list';
import { FeaturedArticle } from '../../featured-article';
import { Container, Wrapper } from '../styles/news.style';
import { TitleImage } from '../../title-image';

const propTypes = {
  articles: PropTypes.array,
};

const defaultProps = {
  articles: [
    {
      node: {},
    },
  ],
};

/**
 * News Component
 */
class News extends React.Component {
  /**
   * News Component Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.state = {
      isMobileLocal: false,
      mounted: false,
    };
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    }
    this.setState({ mounted: true });
  }

  /**
   * Renders a News Component
   * @returns {XML} News Component
   */
  render() {
    const {
      articles, featuredArticle, tagsToPull, titleImage,
    } = this.props;
    const { mounted, isMobileLocal } = this.state;
    let displayArticles = articles.edges;
    displayArticles = displayArticles
      && displayArticles.filter((node) => {
        const article = node.node;
        const { tags } = article;
        const articleId = article.id;
        const featureId = featuredArticle.id;
        const matchesTags = tags && tagsToPull.some(r => tags.indexOf(r) >= 0);
        return articleId !== featureId && matchesTags;
      });
    let articleList = '';
    if (!isMobileLocal && mounted && displayArticles) {
      articleList = (
        <div className={`articles-wrapper ${featuredArticle ? 'with-featured' : ''}`}>
          <div className="article-wrapper-inner">
            <Carousel className="equal-height" numSlides={3} tabletSlides={2} dots auto>
              {displayArticles.map((node, index) => {
                if (node && node.node && node.node.videoStill) {
                  return <VideoArticle key={index} data={node.node} />;
                }
                return <CarouselArticle key={index} data={node.node} />;
              })}
            </Carousel>
          </div>
        </div>
      );
    }
    return (
      <Container>
        <Wrapper>
          <h1 className="section-title">
            <TitleImage src={titleImage && titleImage.file && titleImage.file.url} alt="The News" />
          </h1>
          {featuredArticle ? <FeaturedArticle data={featuredArticle} /> : ''}
          {articleList}
          {isMobileLocal && mounted ? (
            <Link className="more-link" to="/news">
              { 'More Articles' }
              <img src="/images/more-arrow.svg" alt="go" />
            </Link>
          ) : (
            ''
          )}
        </Wrapper>
      </Container>
    );
  }
}

News.propTypes = propTypes;
News.defaultProps = defaultProps;

export default News;



// WEBPACK FOOTER //
// ./src/components/news/components/news.js